import { CamerasPage } from '@/modules/cameras';

export const Cameras = () => {
  return <CamerasPage />;
};
